import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import { z } from 'zod'

export const Inv1140SearchParamsSchema = z
  .object({
    number: z.string().optional(),
    dateFrom: z.coerce.date().optional(),
    dateTo: z.coerce.date().optional(),
    status: z
      .union([z.literal('1'), z.literal('2'), z.literal('3'), z.literal('4')])
      .optional(),
    filterStatus: z.string().optional(),
    lotNo: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type Inv1140SearchParams = z.infer<typeof Inv1140SearchParamsSchema>

export const Inv1140SearchResultModelSchema = z.object({
  id: z.number(),
  number: z.string(),
  date: z.coerce.date(),
  remark: z.string().nullable(),
  status: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]),
})

export type Inv1140SearchResultModel = z.infer<
  typeof Inv1140SearchResultModelSchema
>

export const Inv1140SearchResultSchema = z
  .object({
    data: z.array(Inv1140SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Inv1140SearchResult = z.infer<typeof Inv1140SearchResultSchema>
